module.exports = __webpack_public_path__ + "media/images/pc/specials/common/clean_side-96c8ddde3bc6385ff6df9f16053a26b3.png";